<template>
    <Teleport :to="teleport">
        <div ref="modal" :class="`modal  confirmation-popup ${customOptionalClass}`" tabindex="-1" role="dialog" :id="id">
            <div class="modal-dialog confirmation-popup-width" role="document">
                <div class="modal-content">
                    <div class="modal-header new-design">
                        <h5 class="modal-title d-inline"> {{ title }} </h5>
                        <svg class="close-icon clickable" data-dismiss="modal" aria-label="Close" width="24" height="24"
                             viewBox="0 0 24 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z"
                                  fill="#2E4051"/>

                        </svg>
                    </div>
                    <div class="modal-body">
                        <slot></slot>
                        <div v-html="message"></div>
                    </div>
                    <div class="modal-footer new-design">
                        <div class="col-md-12">
                            <button v-if="showCancelBtn" type="button" data-dismiss="modal" aria-label="Close"
                                    @click="cancel"
                                    class="btn btn-default new-design">{{ cancelBtnText }}
                            </button>
                            <button v-if="showConfirmBtn" type="button" :id="confirmId" @click="confirm" :disabled="isloading"
                                    class="btn btn-primary new-design btn-confirm">
                              <span v-if="!isloading">{{ confirmBtnText }}</span>
                              <img src="/pic/loading-4.gif" v-else>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import Teleport from 'vue2-teleport';

export default {
    name: "ConfirmationPopup",
    components: {Teleport},
    props: {
        id: {
            required: true,
            default() {
                return false
            }
        },
        confirmId: {
            default() {
                return 'confirmButton'
            }
        },
        showConfirmBtn: {
            type: Boolean,
            default() {
                return true
            }
        },
        confirmBtnText: {
            default() {
                return 'Confirm'
            }
        },
        // onConfirm: null,
        showCancelBtn: {
            type: Boolean,
            default() {
                return true
            }
        },
        cancelBtnText: {
            default() {
                return 'Cancel'
            }
        },
        customOptionalClass: {
            default() {
                return ' '
            }
        },
        onCancel: null,
         title: {
            default() {
                return 'Confirmation Dialog'
            }
        },
        message: {
            default() {
                return ''
            }
        },
        parameterForOnConfirm: 0,
        closeAfterConfirm: {
            type: Boolean,
            default() {
                return true
            }
        },
        loading: {
            type: Boolean,
            default() {
                return false
            }
        },
      teleport: {
            type: String,
            default() {
                return 'body'
            }
        },
      beforeClose: {
            type: Promise,
            default:null
        },
    },
  data(){
      return{
        isloading:false,
    };
  },
  methods: {
    async confirm(event) {
      this.loading = true

      this.isloading = true;

      if (this.beforeClose) {
        await this.beforeClose()
        $(this.$refs['modal']).modal('hide')
        this.isloading = false;

      } else {
          this.$emit('on-confirm', event);
          EventBus.$emit('onModalConfirmed')
          this.isloading = false;
          this.loading = false;
      }
        if (this.closeAfterConfirm) {
            $(this.$refs['modal']).modal('hide')
        }

    },
    cancel(event) {
      this.$emit('on-cancel', event)
      $(this.$refs['modal']).modal('hide')
      $('.modal-open').css('overflow', 'unset')
    },
    initiateEventListeners() {
      $(this.$refs['modal']).on('hidden.bs.modal', () => {
        if (this.onCancel) {
          this.onCancel()
        }
      })
    },
  }
}
</script>

<style scoped>
:deep(.modal-footer.new-design)
{
  display: block !important;
}
.admin_declineBookingRequest{
    z-index: 1250 !important ;
}

.modal-header.new-design {
    border-bottom: unset;
}

.has-error .form-control {
    border-color: #a94442 !important;
}

.modal-header.new-design .modal-title {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    color: #2E4051;
    display: inline;
}

.modal-footer.new-design {
    border-top: unset;
    text-align: left;
    padding-top: 0px;
}

.close-icon {
    float: right;
}

.clickable {
    cursor: pointer;
}

.error-label {
    top: 8px;
    position: relative;
}

.btn.new-design {
    border-radius: 8px;
    padding: 12px 16px;
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: #FFFFFF;
}

.btn-primary.new-design {
    background: #2E4051 !important;
    float: right;
}

.btn-default.new-design {
    color: #2E4051
}

.form-control.new-design::placeholder {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.form-control.new-design {
    padding: 16px;
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    box-sizing: border-box;

    height: 56px;

    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.btn.new-design {
    margin-bottom: unset;
}

@media (max-width: 768px) {
    .btn.new-design {
        width: 100%
    }

    .btn-default.new-design {
        margin-bottom: 10px;
    }
}
.confirmation-popup.in .modal-footer.new-design
{
  display: block !important;
}
</style>
